import { Flex } from "@chakra-ui/react";

const Library  = () => {

 

  return (
    



        <Flex
        direction="column"
          p={0}
          w={"100%"}
          gap={8}>

<Flex justifyContent="space-between" direction={{ lg: "row", base: "column" }} gap={4}>
<h1>Library</h1>
            </Flex>

       
           
        
            </Flex>
       
  );
};

export default Library;
